import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import { Provider } from 'react-redux'
import { syncHistoryWithStore } from 'react-router-redux'
import { UserIsAuthenticated, UserIsNotAuthenticated } from './util/wrappers.js'
import getWeb3 from './util/web3/getWeb3'

// Layouts
import App from './App'
import Index from './layouts/Index'
import NotFound from './layouts/NotFound'
import MyWallet from './layouts/mywallet/MyWallet'
import Token from './layouts/token/Token'
import City from './layouts/city/City'
import NewProposal from './layouts/city/NewProposal'
import PayTax from './layouts/city/PayTax'
import EditName from './layouts/city/EditName'
import Citizens from './layouts/city/Citizens'
import Proposal from './layouts/proposal/Proposal'
import Wallet from './layouts/wallet/Wallet'
import Usage from './layouts/usage/Usage'
import '../semantic/dist/semantic.min.css'

// Redux Store
import store from './store'
// Initialize react-router-redux.
const history = syncHistoryWithStore(browserHistory, store)

// Initialize web3 and set in Redux.
getWeb3.then(() => {
    console.log('Web3 initialized!')
}).catch(() => {
    console.log('Error in web3 initialization.')
})

ReactDOM.render((
    <Provider store={store}> 
        <Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
            <Route path="/" component={App}>
                <IndexRoute component={UserIsNotAuthenticated(Index)} />
                <Route path="/wallet" component={UserIsNotAuthenticated(Wallet)} />
                <Route path="/usage" component={Usage} />
                <Route path="/my-wallet" component={UserIsAuthenticated(MyWallet)} />
                <Route path="/token" component={UserIsAuthenticated(Token)} />
                <Route path="/city" component={UserIsAuthenticated(City)} />
                <Route path="/new-proposal" component={UserIsAuthenticated(NewProposal)} />
                <Route path="/pay-tax" component={UserIsAuthenticated(PayTax)} />
                <Route path="/citizens" component={UserIsAuthenticated(Citizens)} />
                <Route path="/edit-name" component={UserIsAuthenticated(EditName)} />
                <Route path="/proposal/:id" component={UserIsAuthenticated(Proposal)} />
                <Route path="*" component={NotFound} />
            </Route>
        </Router>
    </Provider>
  ),
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js